<div class="flex justify-between gap-2 items-center">
    <h2 class="m-0 text-neutral-50 font-normal"><ng-content></ng-content></h2>

    <div class="hover:opacity-50 cursor-pointer" (click)="close()">
        <img src="/assets/svg-icons/close.svg" alt="Sluiten" width="12" height="12">
    </div>
</div>
